import { render } from "./VerEmpresa.vue?vue&type=template&id=6583ecdd"
import script from "./VerEmpresa.vue?vue&type=script&lang=js"
export * from "./VerEmpresa.vue?vue&type=script&lang=js"

import "./VerEmpresa.vue?vue&type=style&index=0&id=6583ecdd&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__